import { render, staticRenderFns } from "./RemuneracaoValidacaoRightNavBar.vue?vue&type=template&id=36496f08"
import script from "./RemuneracaoValidacaoRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoValidacaoRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoValidacaoRightNavBar.vue?vue&type=style&index=0&id=36496f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports